import { ApiService } from 'pf-frontend-common/src/service/api/service';

import { PropertyReportAttachmentModel } from 'common/data/property-report/attachment/model';
import { PropertyReportClaimModel } from 'common/data/property-report/claim/model';
import { PropertyReportEligibilityModel } from 'common/data/property-report/eligibility/model';
import { PropertyReportModel } from 'common/data/property-report/model';
import { PropertyReportStore } from 'common/data/property-report/store';
import { JsonApiStoreFactory } from 'common/module/json-api/store.factory';
import { ApiEndpointService } from 'common/service/api-endpoint/service';
import { UserAuthenticationService } from 'common/service/user-authentication/service';

export function PropertyReportStoreFactory(): PropertyReportStore {
  return new PropertyReportStore(
    ApiEndpointService(),
    ApiService(),
    JsonApiStoreFactory<PropertyReportModel>(PropertyReportModel.JSONAPI_TYPE),
    JsonApiStoreFactory<PropertyReportAttachmentModel>(PropertyReportAttachmentModel.JSONAPI_TYPE),
    JsonApiStoreFactory<PropertyReportEligibilityModel>(PropertyReportEligibilityModel.JSONAPI_TYPE),
    JsonApiStoreFactory<PropertyReportClaimModel>(PropertyReportClaimModel.JSONAPI_TYPE),
    UserAuthenticationService()
  );
}
